module.exports = __webpack_public_path__ + "img/Bouclier01.79e70741.png";